import { render, staticRenderFns } from "./mdbMonthView.vue?vue&type=template&id=39b2b04f&scoped=true&"
import script from "./mdbMonthView.vue?vue&type=script&lang=js&"
export * from "./mdbMonthView.vue?vue&type=script&lang=js&"
import style0 from "./mdbMonthView.vue?vue&type=style&index=0&id=39b2b04f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b2b04f",
  null
  
)

export default component.exports